import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PedidoIntegracaoEcommerceImportService {
    /** Evento executado após finalizar a importação dos pedidos do e-commerce */
    afterImport = new Subject<void>();

    /** Emite o evento de finalização da importação dos pedidos do e-commerce */
    emitAfterImport() {
        this.afterImport?.next();
    }
}
